window.Foundation.registerExtension(($elem) => {
  $elem.find('[data-off-canvas-open]').each(function() {
    $(this).foundation('open', null, null);
  });
});
